import { Injectable } from '@angular/core';
import { Router, CanActivateChild, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';

import { AuthenticationService } from './authentication.service';

/**
 * This guard only allows access to child pages if the user is authenticated with the OIDC framework; otherwise it redirects the user to the login page.
 */
@Injectable()
export class AuthorizationGuard implements CanActivateChild, CanLoad {

	constructor(
		private _Router: Router,
		private _AuthenticationService: AuthenticationService
	) { }

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.CheckAuthorized();
	}

	canLoad(state: Route): Observable<boolean> {
		return this.CheckAuthorized();
	}

	/**
	 * Creates an observable that checks if the current session is authorized and redirects to the login page if it's not.
	 */
	private CheckAuthorized(): Observable<boolean> {
		return new Observable((objObserver: Subscriber<boolean>) => {
			if (this._AuthenticationService.UserClaims == null)
				this._AuthenticationService.GetUserClaims()
					.then(() => {
						objObserver.next(this._AuthenticationService.Authenticated);
						objObserver.complete();
						if (!this._AuthenticationService.Authenticated)
							this._Router.navigate(['/login']);
					});
			else {
				objObserver.next(true);
				objObserver.complete();
			}
		});
	}
	
}